<template>
    <div>
      <div style="height: 10px;"></div>
      <div class="flex contentWidth">
        <div class="user-directory boxShadow">
          <div class="user-directory-title">账号设置</div>
          <scrollactive class="user-directory-boxs" :offset="66">
            <div class="user-directory-subtitle">
            <a href="#bidAccount" title="bidAccount" class="scrollactive-item">账号管理</a>
            <!-- <a href="#changePas" title="changePas" class="scrollactive-item">密码管理</a> -->
            
          </div>
          </scrollactive>
          
        </div>
        <div>
          <BibAccount id="bidAccount"></BibAccount>


        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapActions, mapState } from "vuex";
  import BibAccount from './BingingAccount.vue';
  export default {
    data() {
      return {
       
      };
    },
    components:{BibAccount},
    async created() {
      await this.jobseekerState();
    },
    methods: {
      ...mapActions([
        "jobseekerState"
      ]),
    },
  
    computed: {


     
     
    }
  };
  </script>
  
  <style lang="less" scoped>
  @mianColor:#287CF3;
  @whiteColor:#fff;
  @mainFontCol:rgba(0,0,0,0.85);
  @secondfontCol:rgba(0,0,0,0.5);
  @yellowColor:#FF8A16;

    .user-directory{
      width: 192px;
      background-color: #fff;
      margin-right: 20px;
      height: 144px;
      &-title{
        margin: 16px 24px 0 16px;
        padding-bottom: 10px;
        border-bottom: 1px solid #EBEBEB;
      }
      &-subtitle{
        a{
          display: block;
          padding: 10px 16px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0,0,0,0.65);
        }
        &:hover{
          a{
            color: rgba(0,0,0,0.85);
          }
        }
      }
      &-boxs{
        .is-active {
                // color: #287CF3;
                color: rgba(0,0,0,0.85);;
                font-weight: 500;
                background: #F6F9FC;
        }
      }
      
    }
   

  
  </style>
  